var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavbarCategoryOn = function SvgNavbarCategoryOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF540F",
    fillRule: "evenodd",
    d: "M11.273 11.227h-8.25v-8.25h8.25zm9.75 0h-8.25v-8.25h8.25zm-8.25 9.75h8.25v-8.25h-8.25zm-6.75 0h5.25v-8.25h-8.25v5.25a3 3 0 0 0 3 3",
    clipRule: "evenodd"
  })));
};
export default SvgNavbarCategoryOn;